import React, { useEffect, useState } from "react";
import {getMenu,
  getProductSpecifications,
  updateProductSpecification,
  addProductSpecification,deleteProductSpecification
} from "../../../services/apiService";
import "../styles/specification.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import ReactDOM from "react-dom"
import Select from "react-select";

const SpecificationDetails = () => {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
const [menuList, setMenuList] = useState([]);

  /* Pagination */
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  /* Modal State */
  const [modalOpen, setModalOpen] = useState(false);
  const [editingSpec, setEditingSpec] = useState(null);

  /* Form State (controlled inputs) */
  const [form, setForm] = useState({
    productid: "",
    model_no: "",
    skey: "",
    value: "",
     created_by: localStorage.getItem("userName") || "",
    created_date: new Date().toISOString().split("T")[0],
  });
useEffect(() => {
  if (modalOpen) {
    loadMenu();
  }
}, [modalOpen]);
const productOptions = menuList.map((item) => ({
  value: item.productid,
  label: item.modelno,
}));
const loadMenu = async () => {
  try {
    const res = await getMenu();

    const rawData = res?.Data || [];

    const flattenedProducts = rawData.flatMap((category) =>
      category.Subcategory?.flatMap((sub) =>
        sub.dtls?.map((item) => ({
          productid: item.productid,
          modelno: item.modelno,
        })) || []
      ) || []
    );

    setMenuList(flattenedProducts);

  } catch (error) {
    console.error("Menu API Error:", error);
    setMenuList([]);
  }
};

  useEffect(() => {
    loadSpecs();
  }, []);

  const loadSpecs = async () => {
    const res = await getProductSpecifications();
    setData(res.Data || []);
    setFiltered(res.Data || []);
  };

  /* Search */
  useEffect(() => {
    let temp = [...data];
    if (search) {
      temp = temp.filter((item) =>
        `${item.productid} ${item.model_no} ${item.skey}`
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    setCurrentPage(1);
    setFiltered(temp);
  }, [search, data]);

  /* Pagination */
  const totalPages = Math.ceil(filtered.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const pageData = filtered.slice(startIndex, startIndex + pageSize);

  /* Open Modal */
  const openModal = (spec = null) => {
    if (spec) {
      setEditingSpec(spec);
      setForm({
        productid: spec.productid,
        model_no: spec.model_no,
        skey: spec.skey,
        value: spec.value,
        created_by: spec.created_by,
        created_date: spec.created_date,
      });
    } else {
      setEditingSpec(null);
      setForm({
        productid: "",
        model_no: "",
        skey: "",
        value: "",
         created_by: localStorage.getItem("userName") || "",
        created_date: new Date().toISOString().split("T")[0],
      });
    }
    setModalOpen(true);
  };
const handleMenuChange = (e) => {
  const selectedProductId = e.target.value;

  const selectedMenu = menuList.find(
    (item) => String(item.productid) === String(selectedProductId)
  );

  setForm((prev) => ({
    ...prev,
    productid: selectedProductId,
    model_no: selectedMenu?.modelno || "",  // ✅ FIXED
  }));
};


  const closeModal = () => {
    setEditingSpec(null);
    setModalOpen(false);
  };

  /* Handle Save (Add or Edit) */
  const handleSave = async () => {
    try {
      if (editingSpec) {
        // Edit
        const payload = { ...editingSpec, ...form };
        await updateProductSpecification(editingSpec.id, payload);
        console.log("Specification updated:", payload);
      } else {
        // Add
        const payload = { ...form };
        await addProductSpecification(payload);
        console.log("Specification added:", payload);
      }

      closeModal();
      loadSpecs();
    } catch (error) {
      console.error("Failed to save specification:", error);
      alert("Failed to save specification. Please check all required fields.");
    }
  };
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this specification?")) return;

  try {
    await deleteProductSpecification(id);
    console.log("Specification deleted:", id);
    loadSpecs(); // Refresh the list
  } catch (error) {
    console.error("Failed to delete specification:", error);
    alert("Failed to delete specification. Please try again.");
  }
};

  /* Handle Form Change */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="spec-page">
      <div className="spec-header">
        <h2>Specification Details</h2>

        <div className="spec-actions">
          <input
            type="text"
            placeholder="Search by Product ID"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button className="add-btn" onClick={() => openModal()}>
            Add Specification
          </button>
        </div>
      </div>
     <div
    style={{
      width: "80vw",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
    }}
  >
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Product-ID</th>
              <th>Model No</th>
              <th>Key</th>
              <th>Value</th>
              <th>Created By</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {pageData.map((p, index) => (
              <tr key={p.id}>
                <td>{startIndex + index + 1}</td>
                <td>{p.productid}</td>
                <td>{p.model_no}</td>
                <td>{p.skey}</td>
                <td>{p.value}</td>
                <td>{p.created_by}</td>
                <td>{p.created_date}</td>
                <td>
                  <button className="edit-btn" onClick={() => openModal(p)}>
                    <FaEdit />
                  </button>
                 <button className="delete-btn" onClick={() => handleDelete(p.id)}>
  <FaTrash />
</button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
</div>
      {/* Pagination */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? "active" : ""}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

      {/* Modal */}
      {modalOpen &&  ReactDOM.createPortal(
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{editingSpec ? "Edit Specification" : "Add Specification"}</h3>

            <div className="modal-grid">
              {/* Product ID */}
             

              {/* Model No */}
                 <div className="modal-field">
                      <label>Model no:</label>
<Select
  className="modal-input"
  options={productOptions}
  value={
    productOptions.find(
      (option) => option.value === form.productid
    ) || null
  }
  onChange={(selectedOption) =>
    handleMenuChange({
      target: {
        name: "productid",
        value: selectedOption ? selectedOption.value : "",
      },
    })
  }
  isDisabled={!!editingSpec}
  isSearchable
  placeholder="Select Product"
/>
         </div>
 <div className="modal-field">
                <label>Product ID:</label>
                <input
                  type="text"
                  name="productid"
                  value={form.productid}
                  onChange={handleChange}
                  readOnly 
                />
              </div>

              {/* Key */}
              <div className="modal-field">
                <label>Key:</label>
                <input
                  type="text"
                  name="skey"
                  value={form.skey}
                  onChange={handleChange}
                />
              </div>

              {/* Value */}
              <div className="modal-field">
                <label>Value:</label>
                <input
                  type="text"
                  name="value"
                  value={form.value}
                  onChange={handleChange}
                />
              </div>

              {/* Created By */}
                 <div className="modal-field">
                <label>Created By:</label>
                <input
                  type="text"
                  name="created_by"
                  value={form.created_by}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="modal-field">
                <label>Created By:</label>
                <input type="text" value={form.created_by} readOnly />
              </div> */}

              {/* Created Date */}
              <div className="modal-field">
                <label>Created Date:</label>
                <input type="text" value={form.created_date} readOnly />
              </div>
            </div>

            <div className="modal-actions">
              <button className="save-btn" onClick={handleSave}>
                Save
              </button>
              <button className="cancel-btn" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>,
      
        document.body )}
        <style>{`.modal-field input,
.modal-field select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fff;
  height: 38px;
  box-sizing: border-box;
}

.modal-field select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
`}</style>
    </div>
  );
};

export default SpecificationDetails;
